<template>
  <div class="development">
    <div class="banner" :style="`background-image: url(${bannerUrl})`">
      <div class="banner-content">
        <div class="banner-content-info">
          {{ $t('serviceSupport.simulationPage.pageTitle') }}
          <span></span>
        </div>
      </div>
    </div>

    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/serviceSupport' }">{{ $t('serviceSupport.simulationPage.breadcrumbService') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('serviceSupport.simulationPage.breadcrumbSimulation') }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
      <div class="content-title">{{ $t('serviceSupport.simulationPage.contentTitle') }}</div>
      <div class="content-text">
        {{ $t('serviceSupport.simulationPage.contentText') }}
      </div>
      <img :src="product">
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      bannerUrl: require('@/assets/images/serviceSupport/productBanner4.png'),
      product: require('@/assets/images/serviceSupport/product4.png'),
    }
  }
}

</script>

<style scoped lang="scss">
.development {

  .banner {
    height: 405px;
    display: block;
    margin: 0 auto;
    background-size: 1920px 570px;
    padding-top: 165px;
    .banner-content {
      width: 1200px;
      margin: 0 auto;
      .banner-content-info {
        width: 354px;
        height: 82px;
        border: 1px solid #fff;
        background: rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(20px);
        font-weight: 600;
        font-size: 44px;
        color: #fff;
        padding: 70px 60px 80px;
        span {
          width: 80px;
          height: 4px;
          background: rgba(255, 255, 255, 1);
          display: block;
          margin-top: 16px;
        }
      }
    }
  }
  .el-breadcrumb {
    padding-top: 60px;
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
  }

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 100px;

    .content-title {
      padding-bottom: 80px;
      font-weight: 600;
      font-size: 40px;
      color: #2B3247;
      text-align: center;
    }

    .content-text {
      font-weight: 400;
      font-size: 18px;
      color: rgba(43,50,71,0.7);
      line-height: 32px;
      padding-bottom: 40px;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>